// Copyright 2021 Rennie Glen Software LLC
import { Param } from "./Param";

export class CheckboxParam implements Param<boolean> {
    checked: boolean;
    validate() { return Promise.resolve(this.checked); }
    loadValid(a: any) { this.checked = !!a; }

    constructor(checked = false) {
        this.checked = checked;
    }

    copyFrom(param: Param<boolean>): void {
        const thisType = typeof(this);
        const thatType = typeof(param);
        const that = param as unknown as CheckboxParam;
        if (thisType === thatType) {
            this.checked = that.checked;
        } else {
            throw new Error(`Can't copy from ${thatType} to ${thisType}.`);
        }
    }

    pack() { return this.checked; }
    unpack(x: any) { this.checked = Boolean(x); }
}
